'use client';

/**
 * Lokálne keyframes a triedy pre VOX. Zámerne mimo globals.css - celý VOX je
 * zatiaľ samostatná vrstva. Pri zaradení do produkčnej homepage presunúť
 * do globals.css.
 *
 * Mikrofón: plochý kruh so zlatou plazmou - dve conic vrstvy proti sebe
 * plus svetlé jadro. Rotáciu robí CSS, hlasovú úroveň dodáva VoxMic.tsx
 * cez premennú --lvl (0-1).
 */
export function VoxStyles() {
    return (
        <style
            dangerouslySetInnerHTML={{
                __html: `
@keyframes vox-ring {
  0%   { transform: scale(1);    opacity: .5; }
  70%  { opacity: 0; }
  100% { transform: scale(2.05); opacity: 0; }
}
@keyframes vox-breathe {
  0%, 100% { transform: scale(1);     opacity: .5; }
  50%      { transform: scale(1.085); opacity: .85; }
}
@keyframes vox-spin { to { transform: rotate(360deg); } }
@keyframes vox-spinrev { to { transform: rotate(-360deg); } }
@keyframes vox-pulse {
  0%, 100% { opacity: .95; }
  50%      { opacity: .7; }
}
@keyframes vox-dots {
  0%, 80%, 100% { opacity: .25; transform: translateY(0); }
  40%           { opacity: 1;   transform: translateY(-3px); }
}
@keyframes vox-in {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes vox-mic-in {
  0%   { opacity: 0; transform: scale(.34); clip-path: circle(0% at 50% 50%); }
  55%  { opacity: 1; }
  100% { opacity: 1; transform: scale(1);   clip-path: circle(92% at 50% 50%); }
}
/* Fizz - bublinky z Bolicina intra (logo-fizz), ale opacne: kruhy paduju
   zhora dole. Rovnaka krivka ako iFizz, len zrkadlovy translateY. Kazda
   bublina ma vlastne tempo (--fd), delay (--fdl) a cielovu opacitu (--fo). */
@keyframes vox-fizz {
  0%   { transform: translateY(0) scale(1);      opacity: 0; }
  16%  { opacity: var(--fo, .45); }
  70%  { opacity: calc(var(--fo, .45) * .6); }
  100% { transform: translateY(150px) scale(.3); opacity: 0; }
}
.vox-fizz i {
  position: absolute;
  border-radius: 50%;
  opacity: 0;
  animation: vox-fizz var(--fd, 6s) cubic-bezier(.22,.61,.36,1) var(--fdl, 0s) infinite;
}
@keyframes vox-rise {
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes vox-island-in {
  from { opacity: 0; transform: translateY(-16px) scale(.9); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

.vox-mic-in    { animation: vox-mic-in 1.15s cubic-bezier(.22,.61,.36,1) .12s both; }
.vox-rise      { animation: vox-rise .7s cubic-bezier(.22,.61,.36,1) both; }
.vox-island-in { animation: vox-island-in .46s cubic-bezier(.22,.61,.36,1) both; }
.vox-d1 { animation-delay: .10s; }
.vox-d2 { animation-delay: .55s; }
.vox-d3 { animation-delay: .78s; }
.vox-d4 { animation-delay: .96s; }

.vox-ring   { animation: vox-ring 2.6s cubic-bezier(.22,.61,.36,1) infinite; }
.vox-ring-2 { animation-delay: .85s; }
.vox-ring-3 { animation-delay: 1.7s; }
.vox-breathe{ animation: vox-breathe 3.4s cubic-bezier(.22,.61,.36,1) infinite; }
.vox-spin   { animation: vox-spin 1.6s linear infinite; }
.vox-in     { animation: vox-in .38s cubic-bezier(.22,.61,.36,1) both; }
.vox-dot    { animation: vox-dots 1.2s ease-in-out infinite; }
.vox-dot-2  { animation-delay: .16s; }
.vox-dot-3  { animation-delay: .32s; }

/* Plocha zlata plazma v tlacidle mikrofonu (P1 z miclab/plasma.html).
   Dve conic vrstvy proti sebe plus svetle jadro; vsetko orezane kruhom
   tlacidla. Jadro a halo silnie s hlasom cez --lvl. */
.vox-pl-a {
  background: conic-gradient(from 0deg,#f3c300,#ff9d00,#c47c00,#ffe071,#fff8dc,#f3c300);
  animation: vox-spin 6.5s linear infinite;
  filter: blur(5px);
}
.vox-pl-b {
  background: conic-gradient(from 150deg,rgba(255,251,232,.95) 0deg,rgba(255,251,232,0) 70deg,rgba(255,150,10,.9) 165deg,rgba(255,251,232,0) 260deg,rgba(255,251,232,.95) 360deg);
  animation: vox-spinrev 9s linear infinite;
  mix-blend-mode: screen;
  filter: blur(3.5px);
}
/* ostry dvojity shimmer - mihne sa po povrchu, s hlasom zosilnie */
.vox-pl-c {
  background: conic-gradient(from 80deg,rgba(255,255,255,0) 0deg,rgba(255,255,255,.95) 10deg,rgba(255,255,255,0) 28deg,rgba(255,255,255,0) 140deg,rgba(255,224,113,.85) 165deg,rgba(255,255,255,0) 195deg,rgba(255,255,255,0) 270deg,rgba(255,255,255,.6) 292deg,rgba(255,255,255,0) 318deg,rgba(255,255,255,0) 360deg);
  animation: vox-spin 3.6s linear infinite;
  mix-blend-mode: screen;
  filter: blur(.8px);
  opacity: calc(.6 + var(--lvl,0) * .4);
}
.vox-gring {
  padding: 2px;
  background: conic-gradient(from 20deg,#fff6d8 0%,#f3c300 16%,#c98f00 34%,#ffe071 50%,#f3c300 66%,#fffbe8 82%,#fff6d8 100%);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  animation: vox-spin 12s linear infinite;
  filter: saturate(calc(1 + var(--lvl,0)*.5)) brightness(calc(1 + var(--lvl,0)*.12));
}
/* Spring hover (H6 z hover labu): button skoci s prestrelom, prstenec ho
   dobehne o 70ms neskor, vzadu sa rozoprie makky kruh, plazma sa zaostri. */
.vox-orb { transition: transform .5s cubic-bezier(.3,1.9,.35,1); }
.vox-microot:hover .vox-orb { transform: scale(1.07); }
.vox-microot:active .vox-orb { transform: scale(1.02); }
.vox-ringw { transition: transform .55s cubic-bezier(.3,1.9,.35,1) .07s, filter .35s var(--ease-rx); }
.vox-microot:hover .vox-ringw { transform: scale(1.24); filter: saturate(1.45) brightness(1.07); }
.vox-bgc {
  background: radial-gradient(circle,rgba(243,195,0,.4) 0%,rgba(243,195,0,.12) 55%,rgba(243,195,0,0) 75%);
  transform: scale(.5);
  opacity: 0;
  transition: transform .5s var(--ease-rx) .06s, opacity .4s var(--ease-rx) .06s;
}
.vox-microot:hover .vox-bgc { transform: scale(1.45); opacity: .9; }
.vox-microot:hover .vox-pl-a { filter: blur(3.5px) saturate(1.2); }
.vox-halo {
  background: radial-gradient(circle,rgba(243,195,0,.55) 0%,rgba(243,195,0,.18) 46%,rgba(243,195,0,0) 72%);
  filter: blur(14px);
  opacity: calc(var(--lvl,0) * .9);
  transition: opacity .18s linear;
}

/* F1 pole: flat gradientovy border rotuje nonstop, na fokus sa okolo
   rozleje hruby blurry plasma glow. Rotacia bezi cez @property uhol,
   lebo pill sa nesmie tocit ako element. */
@property --vox-ang { syntax: '<angle>'; initial-value: 0deg; inherits: false; }
@keyframes vox-rot { to { --vox-ang: 360deg; } }
/* ciarky soundwave: jemne dychanie v pokoji, nasobene hlasom cez --lvl */
@keyframes vox-barjump {
  0%, 100% { transform: scaleY(calc(.86 * (1 + var(--lvl,0) * var(--k,.5)))); }
  50%      { transform: scaleY(calc(1.14 * (1 + var(--lvl,0) * var(--k,.5)))); }
}
.vox-bar { animation: vox-barjump 1.7s ease-in-out infinite; }
/* Posuvac rozhovoru - tenky a nenapadny, aby nekrical v bielej karte */
.rx-vox-talk { scrollbar-width: thin; scrollbar-color: rgba(0,0,0,.18) transparent; }
.rx-vox-talk::-webkit-scrollbar { width: 6px; }
.rx-vox-talk::-webkit-scrollbar-track { background: transparent; }
.rx-vox-talk::-webkit-scrollbar-thumb { background: rgba(0,0,0,.16); border-radius: 999px; }
.rx-vox-talk::-webkit-scrollbar-thumb:hover { background: rgba(0,0,0,.28); }
.vox-gb, .vox-fglow {
  position: absolute;
  border-radius: 999px;
  pointer-events: none;
  /* zivy rotujuci zlaty border aj v pokoji (nefocus) */
  animation: vox-rot 5s linear infinite;
}
.vox-gb {
  inset: -1.5px;
  padding: 1.5px;
  background: conic-gradient(from var(--vox-ang),#f3c300,#ffe071,#fff6d8,#ffd84a,#f3c300);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
}
.vox-fglow {
  inset: -7px;
  filter: blur(19px) saturate(1.15);
  opacity: 0;
  /* F2 Golden sunset - zlata tecie do oranzovej a cervenej, teply zapad */
  background: conic-gradient(from var(--vox-ang),#f3c300,#ff8c00,#ff5a3c,#e03616,#ffb52e,#f3c300);
  transition: opacity .4s var(--ease-rx);
}
@keyframes voxl-fpulse { 0%, 100% { opacity: .68; filter: blur(19px) saturate(1.15); } 50% { opacity: 1; filter: blur(23px) saturate(1.3); } }
.vox-fieldw:focus-within .vox-fglow {
  opacity: 1;
  animation: vox-rot 2.6s linear infinite, voxl-fpulse 1s ease-in-out infinite;
}
/* fokus: border zhrubne, zrychli a prejde do F2 golden sunset; pozadie inputu jemne pulzuje */
.vox-gb { transition: padding .3s var(--ease-rx), inset .3s var(--ease-rx), filter .3s var(--ease-rx); }
.vox-fieldw:focus-within .vox-gb {
  inset: -2.5px;
  padding: 2.5px;
  filter: saturate(1.25) brightness(1.05);
  background: conic-gradient(from var(--vox-ang),#f3c300,#ff9d00,#ff6f4d,#ffb52e,#f3c300);
  animation-duration: 2.6s;
}
@keyframes voxl-bgpulse { 0%, 100% { background-color: #fff; } 50% { background-color: #fffbe9; } }
.vox-fieldw:focus-within textarea { animation: voxl-bgpulse 1s ease-in-out infinite; }

/* AI spark v inpute: v kludu staticka, pri aktivnom inpute velka hviezda dycha a mala blika */
.rx-spark-big, .rx-spark-small { transform-box: fill-box; transform-origin: center; }
@keyframes rx-spark-breathe { 0%, 100% { transform: scale(1) rotate(0deg); } 50% { transform: scale(1.14) rotate(12deg); } }
@keyframes rx-spark-twinkle { 0%, 100% { opacity: .35; transform: scale(.7); } 40% { opacity: 1; transform: scale(1.15); } }
.vox-fieldw:focus-within .rx-spark-big { animation: rx-spark-breathe 1.6s var(--ease-rx) infinite; }
.vox-fieldw:focus-within .rx-spark-small { animation: rx-spark-twinkle 1.6s ease-in-out .3s infinite; }
@media (prefers-reduced-motion: reduce) { .rx-spark-big, .rx-spark-small { animation: none !important; } }

@media (prefers-reduced-motion: reduce) {
  .vox-ring, .vox-breathe, .vox-spin, .vox-in, .vox-dot,
  .vox-mic-in, .vox-rise, .vox-island-in,
  .vox-pl-a, .vox-pl-b, .vox-pl-c, .vox-gring, .vox-gb, .vox-fglow,
  .vox-bar, .vox-gfx1, .vox-gfx2 { animation: none !important; }
  .vox-mic-in { clip-path: none !important; }
  .vox-fizz i { animation: none !important; opacity: 0 !important; }
}

/* filter vlozeny do VOX karty: zhodena je jeho vlastna biela karta (tien,
   padding, pozadie) a prepinac na smart filter - polia ostavaju ako na portali */
.vox-filter-embed [class*="rounded-[18px]"] {
  box-shadow: none; border: none; margin-top: 0; padding: 0; background: transparent;
}
.vox-filter-embed label { display: none; }
/* placeholder textu polia sa nesmie lamat do dvoch riadkov */
.vox-filter-embed [class*="h-[40px]"] { white-space: nowrap; }
/* polia filtra nie su plna biela - mliecne sklo, sedia na zlatom pozadi */
.vox-filter-embed [class*="h-[40px]"][class*="overflow-hidden"] {
  background: rgba(255,255,255,.72);
  border-color: rgba(255,255,255,.55);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
}
/* Liquid glass karta: polopriehladne mliecne sklo s backdrop blurom,
   svetla horna hrana a jemny vnutorny ram. V rozhovore sa sklo
   privrie do hustejsej bielej kvoli citatelnosti prepisu. */
.vox-glass {
  background: rgba(255,255,255,.55);
  -webkit-backdrop-filter: blur(22px) saturate(1.15);
  backdrop-filter: blur(22px) saturate(1.15);
  box-shadow:
    0 11px 30px rgba(0,0,0,.15),
    inset 0 1px 0 rgba(255,255,255,.75),
    inset 0 0 0 1px rgba(255,255,255,.35);
  transition: background .4s var(--ease-rx, cubic-bezier(.22,.61,.36,1));
}
.vox-glass-solid { background: rgba(255,255,255,.86); }
/* putujuce svetlo v skle - dve pomale biele/kremove skvrny */
@keyframes vox-gdrift1 {
  0%, 100% { transform: translate(0,0) scale(1); }
  50%      { transform: translate(14%,8%) scale(1.1); }
}
@keyframes vox-gdrift2 {
  0%, 100% { transform: translate(0,0) scale(1); }
  50%      { transform: translate(-12%,-8%) scale(.94); }
}
.vox-gfx1, .vox-gfx2 { position: absolute; border-radius: 50%; pointer-events: none; }
.vox-gfx1 {
  left: -20%; top: -60%; width: 70%; height: 160%;
  background: radial-gradient(circle,rgba(255,255,255,.5) 0%,rgba(255,255,255,0) 65%);
  filter: blur(24px);
  animation: vox-gdrift1 16s ease-in-out infinite;
}
.vox-gfx2 {
  right: -15%; bottom: -60%; width: 60%; height: 150%;
  background: radial-gradient(circle,rgba(255,244,200,.4) 0%,rgba(255,244,200,0) 65%);
  filter: blur(28px);
  animation: vox-gdrift2 21s ease-in-out infinite;
}
/* na skle sa 5px biele obaly poli filtra menia na prstence - spriehladnit */
.vox-filter-embed [class*="p-[5px]"][class*="rounded-[30px]"] { background: transparent; }
/* Vyhladat: len lupa, okruhly button (40 / 45 na xl) */
.vox-filter-embed [class*="group/button"] {
  width: 40px;
  min-width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 999px;
}
.vox-filter-embed [class*="group/button"] p { display: none; }
@media (min-width: 1280px) {
  .vox-filter-embed [class*="group/button"] { width: 45px; min-width: 45px; height: 45px; }
}
/* pomer stlpcov: miesto uzsie, typ inzeratu sirsi - cely placeholder viditelny */
@media (min-width: 768px) {
  .vox-filter-embed [class*="md:grid-cols-"] { grid-template-columns: 36fr 26fr 38fr; }
}
/* vybrana hodnota (zlty pill vo fielde): viac vzduchu po bokoch, nizsi */
.vox-filter-embed [class*="bg-[#f8ebb4]"][class*="rounded-[15px]"] {
  height: auto;
  align-self: center;
  padding: 4px 10px 4px 14px;
}
.vox-filter-embed [class*="mt-[20px]"][class*="justify-center"] { display: none; }

.vox-scroll-light::-webkit-scrollbar { width: 6px; }
.vox-scroll-light::-webkit-scrollbar-thumb { background: rgba(0,0,0,.14); border-radius: 3px; }
.vox-scroll-light::-webkit-scrollbar-track { background: transparent; }

/* ===== VoxMicLauncher varianty (len maly pill v hero inpute) ===== */
/* V1 deep liquid - plazma bez bielych/kremovych segmentov, drzi sytost */
.voxl-deep-a {
  background: conic-gradient(from 0deg,#f3c300,#ffb200,#e8a800,#ffcf1a,#ffdb4d,#f3c300);
  animation: vox-spin 6.5s linear infinite;
  filter: blur(5px);
}
.voxl-deep-b {
  background: conic-gradient(from 150deg,rgba(255,190,30,.85) 0deg,rgba(255,190,30,0) 70deg,rgba(235,170,0,.92) 165deg,rgba(255,190,30,0) 260deg,rgba(255,190,30,.85) 360deg);
  animation: vox-spinrev 9s linear infinite;
  filter: blur(3.5px);
}
/* pendulum rim - zlato sa prelieva po obvode zo strany na stranu (ziadna rotacia) */
@keyframes voxl-swing { 0%, 100% { --vox-ang: 40deg; } 50% { --vox-ang: 150deg; } }
.voxl-rim {
  padding: 2px;
  background: conic-gradient(from var(--vox-ang,90deg),rgba(243,195,0,0) 0deg,#f3c300 60deg,rgba(255,219,77,.9) 100deg,rgba(243,195,0,0) 170deg,rgba(243,195,0,0) 360deg);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  animation: voxl-swing 3.4s ease-in-out infinite;
  filter: blur(.6px);
}
/* radar vnutri cierneho idle kruhu - gradientovy sweep s chvostom */
.voxl-radar {
  background: conic-gradient(from var(--vox-ang,0deg),rgba(243,195,0,.34) 0deg,rgba(243,195,0,.13) 50deg,rgba(243,195,0,0) 125deg,rgba(243,195,0,0) 360deg);
  animation: vox-rot 4s linear infinite;
  filter: blur(.5px);
}
/* klik = intense mode: bars behaju rychlejsie (inline duration prebijeme) */
.voxl-live .vox-bar { animation-duration: .55s !important; }
.voxl-deep-c {
  background: conic-gradient(from 80deg,rgba(255,224,113,0) 0deg,rgba(255,224,113,.9) 12deg,rgba(255,224,113,0) 30deg,rgba(255,224,113,0) 160deg,rgba(255,200,60,.7) 180deg,rgba(255,224,113,0) 200deg,rgba(255,224,113,0) 360deg);
  animation: vox-spin 3.6s linear infinite;
  filter: blur(1px);
  opacity: .8;
}

/* stlmeny variant pre chat dock: rovnaky prvok ako v hero, len jemnejsia ignicia -
   plny bloom posobil v malom docku prehnane (Samov podnet z 26.8.). */
.voxl-calm .voxl-deep-a { filter: blur(6px); }
.voxl-calm .voxl-deep-b { filter: blur(4.5px); }
.voxl-calm:hover .voxl-deep-a { opacity: .55 !important; }
.voxl-calm:hover .voxl-deep-b { opacity: .5 !important; }
.voxl-calm:hover .voxl-deep-c { opacity: .35 !important; }
.voxl-calm:active { transform: scale(.99); }

/* ===== Realica (AI asistentka) chat dock ===== */
/* panel vstup: jemny lift + scale, nie len fade */
@keyframes rxc-panel-in {
  0%   { opacity: 0; transform: translateY(18px) scale(.985); }
  100% { opacity: 1; transform: translateY(0)    scale(1);    }
}
.rxc-panel-in { animation: rxc-panel-in .42s var(--ease-rx) both; }

/* sprava: postupny nabeh zdola (stagger cez inline delay) */
@keyframes rxc-msg-in {
  0%   { opacity: 0; transform: translateY(8px); }
  100% { opacity: 1; transform: translateY(0);   }
}
.rxc-msg { animation: rxc-msg-in .4s var(--ease-rx) both; }

/* chip: jemny nabeh + zlaty shimmer pri hover */
@keyframes rxc-chip-in {
  0%   { opacity: 0; transform: translateY(6px); }
  100% { opacity: 1; transform: translateY(0);   }
}
.rxc-chip {
  animation: rxc-chip-in .45s var(--ease-rx) both;
  background:
    linear-gradient(#fff,#fff) padding-box,
    linear-gradient(120deg,rgba(243,195,0,.55),rgba(255,224,113,.25) 45%,rgba(201,143,0,.4)) border-box;
  border: 1px solid transparent;
  transition: transform .2s var(--ease-rx), box-shadow .25s var(--ease-rx), background-color .2s var(--ease-rx);
}
.rxc-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px -8px rgba(201,143,0,.5), 0 0 0 3px rgba(243,195,0,.1);
}
.rxc-chip:active { transform: translateY(0); }

/* ambient zlaty nadych za spravami - nahradza prazdnotu, nie error */
.rxc-ambient {
  background:
    radial-gradient(120% 80% at 88% 0%, rgba(243,195,0,.14) 0%, rgba(243,195,0,0) 60%),
    radial-gradient(90% 70% at 6% 4%, rgba(255,224,113,.12) 0%, rgba(255,224,113,0) 55%);
}

/* avatar iskry: jemny nekonecny dych */
@keyframes rxc-spark {
  0%,100% { transform: scale(1);    opacity: 1;   }
  50%     { transform: scale(1.12); opacity: .85; }
}
.rxc-spark { animation: rxc-spark 3.2s ease-in-out infinite; }

/* typing dots (ked engine "premysla") */
@keyframes rxc-dot { 0%,60%,100% { transform: translateY(0); opacity:.45; } 30% { transform: translateY(-3px); opacity:1; } }
.rxc-dot { animation: rxc-dot 1.1s ease-in-out infinite; }

@media (prefers-reduced-motion: reduce) {
  .rxc-panel-in, .rxc-msg, .rxc-chip, .rxc-spark, .rxc-dot { animation: none !important; }
}
`,
            }}
        />
    );
}
